import { render, staticRenderFns } from "./SingleDocuments.vue?vue&type=template&id=1067ca34&"
import script from "./SingleDocuments.vue?vue&type=script&lang=js&"
export * from "./SingleDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/pp-weberbuero-50965/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1067ca34')) {
      api.createRecord('1067ca34', component.options)
    } else {
      api.reload('1067ca34', component.options)
    }
    module.hot.accept("./SingleDocuments.vue?vue&type=template&id=1067ca34&", function () {
      api.rerender('1067ca34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/SingleDocuments.vue"
export default component.exports